const CsvIcon = ({
  color = "#db0b27",
  width = 18,
  height = 18,
  strokeWidth = 1.25,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="CSV icon"
    {...props}
  >
    <path
      d="M7.57825 10.68C7.53992 9.85331 6.97575 9.83331 6.20909 9.83331C5.02909 9.83331 4.83325 10.115 4.83325 11.2225V12.6108C4.83325 13.7183 5.02909 14 6.20909 14C6.97575 14 7.54075 13.98 7.57825 13.1533M16.4999 9.83331L15.2808 13.0933C15.0541 13.6975 14.9416 14 14.7624 14C14.5833 14 14.4708 13.6975 14.2441 13.0933L13.0249 9.83331M11.2674 9.83331H10.4574C10.1333 9.83331 9.97158 9.83331 9.84408 9.88581C9.40908 10.0658 9.41492 10.4891 9.41492 10.875C9.41492 11.2608 9.40908 11.6833 9.84408 11.8641C9.97158 11.9166 10.1333 11.9166 10.4574 11.9166C10.7808 11.9166 10.9433 11.9166 11.0708 11.9691C11.5058 12.1491 11.4999 12.5725 11.4999 12.9583C11.4999 13.3441 11.5058 13.7666 11.0708 13.9475C10.9433 14 10.7808 14 10.4574 14H9.57409"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M11.5 17.3333H7.93917C5.2225 17.3333 3.8625 17.3333 2.91917 16.6683C2.65071 16.4801 2.41075 16.2541 2.20667 15.9975C1.5 15.1092 1.5 13.8308 1.5 11.2725V9.15166C1.5 6.68249 1.5 5.44749 1.89083 4.46166C2.51917 2.87582 3.8475 1.62582 5.5325 1.03416C6.57917 0.666656 7.89 0.666656 10.515 0.666656C12.0133 0.666656 12.7633 0.666657 13.3617 0.876657C14.3242 1.21499 15.0833 1.92916 15.4425 2.83499C15.6667 3.39832 15.6667 4.10416 15.6667 5.51499V7.33332"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M1.5 8.99999C1.5 8.26335 1.79263 7.55688 2.31351 7.036C2.83439 6.51512 3.54086 6.22249 4.2775 6.22249C4.8325 6.22249 5.48667 6.31916 6.02583 6.17499C6.26142 6.11159 6.47621 5.98737 6.64865 5.81478C6.82109 5.64219 6.94513 5.4273 7.00833 5.19166C7.1525 4.65249 7.05583 3.99832 7.05583 3.44332C7.05605 2.70683 7.34878 2.00057 7.86964 1.47987C8.3905 0.959171 9.09684 0.666656 9.83333 0.666656"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);
export default CsvIcon;
